import { useEffect, useState } from 'react';
import { BottomActionBarV2, DialogV2, AritoIcon, AritoFormV2 } from '@/components/custom/erp';
import { FormSchema, FormValues, initialFormValues } from '../schema';
import BasicInfoTab from './form-fields/BasicInfoTab';
import { DeleteDialog } from '.';

interface FormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: FormValues) => void;
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
  formMode: 'add' | 'edit' | 'view';
  initialData?: FormValues;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
}

const FormDialog = ({
  open,
  onClose,
  onSubmit,
  onAdd,
  onEdit,
  onDelete,
  onCopy,
  formMode,
  initialData,
  onAddButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
  onCopyButtonClick
}: FormDialogProps) => {
  const [isFormDirty, setIsFormDirty] = useState<boolean>(false);

  const handleSubmit = (data: FormValues) => {
    onSubmit(data);
    setIsFormDirty(false);
    onClose();
  };

  useEffect(() => {
    if (!open) {
      setIsFormDirty(false);
    }
  }, [open]);

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={`${formMode === 'add' ? 'Mới' : formMode === 'edit' ? 'Sửa' : 'Danh mục đợt thanh toán'}`}
        maxWidth='xl'
        disableBackdropClose={false}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
        actions={<></>}
      >
        <AritoFormV2
          mode={formMode}
          hasAritoActionBar={false}
          schema={FormSchema}
          onSubmit={handleSubmit}
          initialData={initialData || initialFormValues}
          className='w-[800px]'
          headerFields={
            <div className='max-h-[calc(100vh-150px)] overflow-y-auto' onChange={() => setIsFormDirty(true)}>
              <BasicInfoTab formMode={formMode} />
            </div>
          }
          bottomBar={
            <>
              {formMode === 'view' && (
                <BottomActionBarV2
                  mode={formMode}
                  onSubmit={() => {}}
                  onClose={onClose}
                  onAdd={onAddButtonClick || onAdd}
                  onEdit={onEditButtonClick || onEdit}
                  onDelete={onDeleteButtonClick || onDelete}
                  onCopy={onCopyButtonClick || onCopy}
                />
              )}
              {formMode !== 'view' && <BottomActionBarV2 mode={formMode} onSubmit={() => {}} onClose={onClose} />}
            </>
          }
        />
      </DialogV2>
    </>
  );
};

export default FormDialog;
